import BaseEntity from './BaseEntity';
import { IndicatorModel } from './2d/indicatorModel';
import { IIndicatorEntityParams } from './type';
import { worldPosToClientPos } from '../utils';
import { globalStores } from '../stores';

export class IndicatorEntity extends BaseEntity {
  private _indicatorModel: IndicatorModel;

  constructor() {
    super();
    this._indicatorModel = new IndicatorModel();
  }

  override update({ center, label, forceUpdate, side }: IIndicatorEntityParams) {
    const {
      renderer,
      scene2d: { camera }
    } = globalStores.editorStateStore.sceneInfo;
    const position = worldPosToClientPos(center, camera, renderer);
    if (forceUpdate) {
      this._indicatorModel.create();
      this._indicatorModel.update({ position, label, side });
    }
    this._indicatorModel.update({ position });
  }

  clear() {
    this._indicatorModel.clear();
  }
}
